// src/pages/Admin/campaigns/constants/menuMap.ts
import { Icons } from '@/icons';
import { JSX } from 'react';
import { Status } from '../types';

export type MenuDescriptor = {
  key: string;
  label: string;
  icon: JSX.Element;
  to?: string; // NavLink destination  (optional)
  action?: () => void; // plain click handler (optional)
};

export const MENU_MAP: Record<Status, MenuDescriptor[]> = {
  Pending: [
    {
      key: 'preview',
      label: 'Preview',
      icon: <Icons.Preview />,
      to: '/admin/campaign/preview',
    },
    { key: 'approve', label: 'Approve', icon: <Icons.Approve /> },
    { key: 'reject', label: 'Reject', icon: <Icons.Reject /> },
    { key: 'remove', label: 'Remove from History', icon: <Icons.Remove /> },
  ],

  Completed: [
    {
      key: 'preview',
      label: 'Preview',
      icon: <Icons.Preview />,
      to: '/admin/campaign/preview',
    },
    // { key: 'sponsor', label: 'Mark as Sponsored', icon: <Icons.Sponsored /> },
  ],

  Paused: [
    {
      key: 'preview',
      label: 'Preview',
      icon: <Icons.Preview />,
      to: '/admin/campaign/preview',
    },
    // { key: 'publish', label: 'Re Publish', icon: <Icons.Publish /> },
    // { key: 'remove', label: 'Remove from History', icon: <Icons.Remove /> },
  ],

  Rejected: [
    {
      key: 'preview',
      label: 'Preview',
      icon: <Icons.Preview />,
      to: '/admin/campaign/preview',
    },
    { key: 'remove', label: 'Remove from History', icon: <Icons.Remove /> },
  ],
  Approved: [
    {
      key: 'preview',
      label: 'Preview',
      icon: <Icons.Preview />,
      to: '/admin/campaign/preview',
    },
    // { key: 'sponsor', label: 'Mark as Sponsored', icon: <Icons.Sponsored /> },
    { key: 'remove', label: 'Remove from History', icon: <Icons.Remove /> },
  ],
  Active: [
    {
      key: 'preview',
      label: 'Preview',
      icon: <Icons.Preview />,
      to: '/admin/campaign/preview',
    },
    { key: 'remove', label: 'Remove from History', icon: <Icons.Remove /> },
  ],
};
